export type CharacterType = 'fairy' | 'elf';

export interface CharacterConfig {
  type: CharacterType;
  skin: string;
  hair: string;
  outfit: string;
  wings: string;
}

export const SKIN_COLORS = [
  '#fde0c8', '#f4c9a1', '#d8a074', '#a67451', '#6d4a32',
  '#f2d7d7', '#d9c2ff',
];
export const HAIR_COLORS = [
  '#3a2a1c', '#7a4a2a', '#d6b168', '#f0dbae', '#ff7aa8',
  '#a47bff', '#8fd8ff', '#ffffff',
];
export const OUTFIT_COLORS = [
  '#ff7aa8', '#ffb8d1', '#cfbfff', '#b8f2d8', '#fff6e5',
  '#a47bff', '#8fd8ff', '#ffd18f', '#6ed49a',
];
export const WING_COLORS = [
  '#ffe0f0', '#e3d7ff', '#d7f5ff', '#fff6d7', '#ffd7e8',
];

export function defaultCharacter(): CharacterConfig {
  return {
    type: 'fairy',
    skin: SKIN_COLORS[0],
    hair: HAIR_COLORS[4],
    outfit: OUTFIT_COLORS[2],
    wings: WING_COLORS[1],
  };
}
